/**
 * search page service module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/16
 */
import * as urls from '../config/urls';
import * as utils from '../utils/fetch';

export const queryProduct = (query, current=1) => {
//   return utils.get(`${urls.queryProduct}q=${query}&current=${current}`);
  return utils.get(urls.queryProduct, {q: query, current: current});

//   return {
//     "code": 200,
//     "msg": "请求成功",
//     "data": {
//         "resultList": [{
//             "id": 521,
//             "name": "魅族 魅蓝 Note",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 525,
//             "name": "魅族 魅蓝 Note 2",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 529,
//             "name": "魅族 魅蓝 Note 3",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 540,
//             "name": "魅族 魅蓝 Note 5",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 548,
//             "name": "魅族 魅蓝 Note6",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 4226,
//             "name": "魅蓝 note",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 4229,
//             "name": "魅蓝 note 2",
//             "price": 10.0,
//             "imageUrl": null
//         }, {
//             "id": 245,
//             "name": "华为 荣耀 Note8",
//             "price": 10.0,
//             "imageUrl": null
//         }],
//         "pageSize": 8,
//         "totalCount": 42,
//         "totalPages": 6,
//         "current": 1
//     },
//     "success": true
// }
}

export const getSearchTip = (query) => {
    return utils.get(urls.searchTip, {q: query});

    // return {
    //     "code": 200,
    //     "msg": "请求成功",
    //     "data": [
    //     {
    //     "id": 342,
    //     "name": "魅族 魅蓝 Note",
    //     "price": 0
    //     },
    //     {
    //     "id": 346,
    //     "name": "魅族 魅蓝 Note 2",
    //     "price": 0
    //     },
    //     {
    //     "id": 350,
    //     "name": "魅族 魅蓝 Note 3",
    //     "price": 0
    //     },
    //     {
    //     "id": 362,
    //     "name": "魅族 魅蓝 Note 5",
    //     "price": 0
    //     },
    //     {
    //     "id": 370,
    //     "name": "魅族 魅蓝 Note6",
    //     "price": 0
    //     },
    //     {
    //     "id": 4875,
    //     "name": "魅蓝 note",
    //     "price": 0
    //     },
    //     {
    //     "id": 4878,
    //     "name": "魅蓝 note 2",
    //     "price": 0
    //     },
    //     {
    //     "id": 4881,
    //     "name": "魅蓝 note 3",
    //     "price": 0
    //     },
    //     {
    //     "id": 139,
    //     "name": "华为 荣耀 Note8",
    //     "price": 0
    //     },
    //     {
    //     "id": 278,
    //     "name": "联想 黄金斗士 Note8（A938t）",
    //     "price": 0
    //     }
    //     ],
    //     "success": true
    //     }
}


// WEBPACK FOOTER //
// ./src/services/search.js